module.exports = __webpack_public_path__ + "static/RobotoCondensed-Regular-a5a6b71255dc832da585d5c94fa1a115.ttf";